export default "__VITE_ASSET__CddEcPCw__"